// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2-YV3","errorLogs":"EditorFooter_errorLogs__dBnbw"};